export default __webpack_public_path__ + "static/media/116-M6018.82e72107.png";